import AddTextSpaceBelow from '../AddTextSpaceBelow';
import Formatting from '../Formatting';
import Finish from '../Finish';
import TopicDetails from '../TopicDetails';
import ContentLesson from '../ContentLesson';
import InitialInformation from '../InitialInformation';
import { modalLessonType } from '../helpers';

export const MODAL_TYPES = {
  INITIAL_INFORMATION: 'INITIAL_INFORMATION',
  ADD_TEXT_SPACE_BELOW: 'ADD_TEXT_SPACE_BELOW',
  CONTENT_LESSON: 'CONTENT_LESSON',
  TOPIC_DETAILS: 'TOPIC_DETAILS',
  FORMATTING: 'FORMATTING',
  FINISH: 'FINISH',
};

export const MODAL_COMPONENTS = {
  [MODAL_TYPES.INITIAL_INFORMATION]: {
    ModalBody: InitialInformation,
    title: t('actions.lesson_generate_modal.generate_lesson_ai'),
    subheader: t('actions.lesson_generate_modal.need_help_creating_lesson'),
    previous: null,
    next: (lessonType, lessonContent, contentVersionId, setContentVersionId) =>
      modalLessonType(
        lessonType,
        lessonContent,
        contentVersionId,
        setContentVersionId,
      ),
  },
  [MODAL_TYPES.ADD_TEXT_SPACE_BELOW]: {
    ModalBody: AddTextSpaceBelow,
    title: t('actions.lesson_generate_modal.add_text_space_below'),
    subheader: t('actions.lesson_generate_modal.best_results'),
    previous: MODAL_TYPES.INITIAL_INFORMATION,
    next: MODAL_TYPES.FORMATTING,
  },
  [MODAL_TYPES.CONTENT_LESSON]: {
    ModalBody: ContentLesson,
    title: t('actions.lesson_generate_modal.select_content_lessson'),
    subheader: t(
      'actions.lesson_generate_modal.select_content_lesson_subheader',
    ),
    previous: MODAL_TYPES.INITIAL_INFORMATION,
    next: MODAL_TYPES.FORMATTING,
  },
  [MODAL_TYPES.TOPIC_DETAILS]: {
    ModalBody: TopicDetails,
    title: t('actions.lesson_generate_modal.topic_details'),
    subheader: t('actions.lesson_generate_modal.topic_details_helper'),
    previous: MODAL_TYPES.INITIAL_INFORMATION,
    next: MODAL_TYPES.FORMATTING,
  },
  [MODAL_TYPES.FORMATTING]: {
    ModalBody: Formatting,
    title: t('actions.lesson_generate_modal.how_do_you_want'),
    subheader: t('actions.lesson_generate_modal.we_can_generate'),
    previous: (
      lessonType,
      lessonContent,
      contentVersionId,
      setContentVersionId,
    ) =>
      modalLessonType(
        lessonType,
        lessonContent,
        contentVersionId,
        setContentVersionId,
      ),
    next: MODAL_TYPES.FINISH,
  },
  [MODAL_TYPES.FINISH]: {
    ModalBody: Finish,
    title: t('actions.lesson_generate_modal.we_will_take_it'),
    subheader: t('actions.lesson_generate_modal.our_ai_is_generating'),
    previous: MODAL_TYPES.FORMATTING,
    next: null,
  },
};

export const LESSON_TYPES = {
  CONTENT: 'content',
  TOPIC: 'topic',
};

export const LESSON_CONTENT_TYPES = {
  TEXT: 'text',
  SEISMIC: 'seismic',
};

export const FORMATTING_CHOICES = [
  {
    title: t('actions.lesson_generate_modal.apply_best_practices'),
    subheader: t('actions.lesson_generate_modal.apply_best_practices_helper'),
    value: true,
  },
  {
    title: t('actions.lesson_generate_modal.generate_with_text'),
    subheader: t('actions.lesson_generate_modal.generate_with_text_helper'),
    value: false,
  },
];

export const LESSON_CONTENT_TYPES_CHOICES = [
  {
    text: t('actions.lesson_generate_modal.give_text'),
    value: LESSON_CONTENT_TYPES.TEXT,
  },
  {
    text: t('actions.lesson_generate_modal.upload_seismic'),
    value: LESSON_CONTENT_TYPES.SEISMIC,
  },
];
